export const tr = {
    'add-minus-word': 'Negatif anahtar sözcüklere ekle'
};
